module.exports = __webpack_public_path__ + "img/智慧城市.383bb053.png";